import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks, siteBrand } from "@/mocks/site";

export default function SiteHeader() {
  const [solid, setSolid] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 32);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const light = !solid && !menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid || menuOpen
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-20 w-full max-w-[1320px] items-center justify-between px-5 md:px-8">
        <Link to="/" className="flex cursor-pointer items-center gap-3" aria-label={`${siteBrand.fullName} 首页`}>
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-xl font-bold tracking-wide transition-colors ${
                light ? "text-background-50" : "text-foreground-950"
              }`}
            >
              {siteBrand.name}
            </span>
            <span
              className={`mt-1 text-[10px] tracking-[0.22em] transition-colors ${
                light ? "text-background-200" : "text-foreground-500"
              }`}
            >
              CONFIDENTIAL TIPS
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `cursor-pointer rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  light
                    ? isActive
                      ? "text-accent-300"
                      : "text-background-100 hover:text-accent-300"
                    : isActive
                      ? "text-primary-600"
                      : "text-foreground-700 hover:text-primary-600"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/submit"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-shield-keyhole-line text-base"></i>
            立即提交线索
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border transition-colors md:hidden ${
              light
                ? "border-background-50/30 text-background-50"
                : "border-background-300 text-foreground-900"
            }`}
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-5 pb-6 pt-3 md:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `flex cursor-pointer items-center justify-between border-b border-background-200 py-4 text-base font-medium transition-colors ${
                    isActive ? "text-primary-600" : "text-foreground-800"
                  }`
                }
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </NavLink>
            ))}
          </nav>
          <Link
            to="/submit"
            className="mt-5 flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50"
          >
            <i className="ri-shield-keyhole-line text-base"></i>
            立即提交线索
          </Link>
        </div>
      )}
    </header>
  );
}